module.exports = __webpack_public_path__ + "static/media/inbox_model.b0e16fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/inbox_model.png
// module id = 282
// module chunks = 0